(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["optional-vitamin-add-ons"] && !Shopify.designMode) return;
  try {
    function stackwellFormatMoney(cents) {
return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
style: 'currency',
currency: 'CAD'
}).format(cents / 100);
}

function initializeStackwellAddOns(root) {
if (!root || root.dataset.initialized === 'true') return;

root.dataset.initialized = 'true';

const maxPerVitamin = Number(root.dataset.maxPerVitamin || 4);
const maxTotal = Number(root.dataset.maxTotal || 12);

const totalElement = root.querySelector('[data-stackwell-total]');
const counterElement = root.querySelector('[data-stackwell-counter]');
const messageElement = root.querySelector('[data-stackwell-message]');
const toggle = root.querySelector('[data-stackwell-toggle]');

let messageTimer;

const items = Array.from(
root.querySelectorAll('[data-stackwell-add-on]')
).map((item) => ({
item,
checkbox: item.querySelector('.stackwell-add-on__checkbox'),
minusButton: item.querySelector('[data-quantity-minus]'),
plusButton: item.querySelector('[data-quantity-plus]'),
quantityValue: item.querySelector('[data-quantity-value]'),
linePrice: item.querySelector('[data-line-price]'),
unitPrice: Number(item.dataset.unitPrice || 0),
quantity: 1
}));

const getTotalSelected = () => {
return items.reduce((total, entry) => {
return total + (entry.checkbox.checked ? entry.quantity : 0);
}, 0);
};

const showMessage = (message) => {
if (!messageElement) return;

window.clearTimeout(messageTimer);

messageElement.textContent = message;
messageElement.hidden = false;

messageTimer = window.setTimeout(() => {
messageElement.hidden = true;
messageElement.textContent = '';
}, 3000);
};

const updateAll = () => {
const totalSelected = getTotalSelected();
const totalLimitReached = totalSelected >= maxTotal;

if (totalElement) {
totalElement.textContent = String(totalSelected);
}

if (counterElement) {
counterElement.classList.toggle(
'is-at-limit',
totalLimitReached
);
}

items.forEach((entry) => {
entry.quantityValue.textContent = String(entry.quantity);
entry.item.dataset.quantity = String(entry.quantity);

entry.linePrice.textContent =
`+${stackwellFormatMoney(entry.unitPrice * entry.quantity)}`;

entry.minusButton.disabled =
!entry.checkbox.checked || entry.quantity <= 1;

entry.plusButton.disabled =
!entry.checkbox.checked ||
entry.quantity >= maxPerVitamin ||
totalLimitReached;
});
};

if (toggle) {
toggle.addEventListener('click', () => {
const expanded = root.classList.toggle('is-expanded');

toggle.setAttribute('aria-expanded', String(expanded));
toggle.querySelector('[data-toggle-show]').hidden = expanded;
toggle.querySelector('[data-toggle-hide]').hidden = !expanded;

/*
* When the customer closes the full vitamin list,
* smoothly return them to the Add to Cart button.
*/
if (!expanded) {
window.requestAnimationFrame(() => {
const productFormComponent = root.closest(
'product-form-component'
);

const addToCartButton =
productFormComponent?.querySelector(
'[type="submit"][name="add"]'
);

if (addToCartButton) {
addToCartButton.scrollIntoView({
behavior: 'smooth',
block: 'center'
});
} else {
toggle.scrollIntoView({
behavior: 'smooth',
block: 'center'
});
}
});
}
});
}

items.forEach((entry) => {
entry.checkbox.addEventListener('change', () => {
if (entry.checkbox.checked) {
if (getTotalSelected() > maxTotal) {
entry.checkbox.checked = false;

showMessage(
`Maximum of ${maxTotal} extra daily servings per stack.`
);
}
} else {
entry.quantity = 1;
}

updateAll();
});

entry.minusButton.addEventListener('click', () => {
if (entry.quantity > 1) {
entry.quantity -= 1;
updateAll();
}
});

entry.plusButton.addEventListener('click', () => {
const totalSelected = getTotalSelected();

if (entry.quantity >= maxPerVitamin) {
showMessage(
`Maximum of ${maxPerVitamin} servings per supplement.`
);
return;
}

if (totalSelected >= maxTotal) {
showMessage(
`Maximum of ${maxTotal} extra daily servings per stack.`
);
return;
}

entry.quantity += 1;
updateAll();
});
});

updateAll();
}

function initializeAllStackwellAddOns() {
document
.querySelectorAll('[data-stackwell-add-ons]')
.forEach(initializeStackwellAddOns);
}

function initializeStackwellCartConnection(root) {
if (!root || root.dataset.cartConnected === 'true') return;

const productFormComponent = root.closest(
'product-form-component'
);

const form = productFormComponent?.querySelector('form');

if (!form) {
console.warn(
'Stackwell add-ons: product form could not be found.'
);
return;
}

const originalSubmitHandler =
productFormComponent.getAttribute('on:submit') || '/handleSubmit';

function syncThemeSubmitHandler() {
const hasSelectedAddOns = Array.from(
root.querySelectorAll('.stackwell-add-on__checkbox')
).some((checkbox) => checkbox.checked);

if (hasSelectedAddOns) {
productFormComponent.removeAttribute('on:submit');
} else {
productFormComponent.setAttribute(
'on:submit',
originalSubmitHandler
);
}
}

root
.querySelectorAll('.stackwell-add-on__checkbox')
.forEach((checkbox) => {
checkbox.addEventListener('change', syncThemeSubmitHandler);
});

syncThemeSubmitHandler();

root.dataset.cartConnected = 'true';

form.addEventListener(
'submit',
async (event) => {
const selectedAddOns = Array.from(
root.querySelectorAll('[data-stackwell-add-on]')
).filter((item) => {
const checkbox = item.querySelector(
'.stackwell-add-on__checkbox'
);

return checkbox?.checked;
});

/*
* When no add-ons are selected, allow Savor's normal
* Add to Cart system to handle the purchase.
*/
if (selectedAddOns.length === 0) return;

event.preventDefault();
event.stopImmediatePropagation();

const submitButton = form.querySelector(
'[type="submit"][name="add"]'
);

const messageElement = root.querySelector(
'[data-stackwell-message]'
);

const formData = new FormData(form);

const baseVariantId = Number(
formData.get('id') || root.dataset.baseVariantId
);

const baseQuantity = Math.max(
1,
Number(formData.get('quantity') || 1)
);

const sellingPlan = formData.get('selling_plan');

const items = [
{
id: baseVariantId,
quantity: baseQuantity
}
];

/*
* Preserve the subscription choice on the base stack.
*/
if (sellingPlan) {
items[0].selling_plan = Number(sellingPlan);
}

selectedAddOns.forEach((item) => {
const checkbox = item.querySelector(
'.stackwell-add-on__checkbox'
);

const addOnItem = {
id: Number(checkbox.dataset.variantId),
quantity: Math.max(
1,
Number(item.dataset.quantity || 1)
),
properties: {
'_Stackwell add-on': 'Yes'
}
};

/*
* Apply the same subscription plan to each add-on.
* This requires the add-on products to be included in
* the same Appstle subscription plan.
*/
if (sellingPlan) {
addOnItem.selling_plan = Number(sellingPlan);
}

items.push(addOnItem);
});

if (!baseVariantId) {
if (messageElement) {
messageElement.textContent =
'Please select a product option before adding this stack.';
messageElement.hidden = false;
}

return;
}

if (submitButton) {
submitButton.disabled = true;
submitButton.setAttribute('aria-busy', 'true');
}

if (messageElement) {
messageElement.hidden = true;
messageElement.textContent = '';
}

try {
const rootUrl =
window.Shopify?.routes?.root || '/';

const response = await fetch(
`${rootUrl}cart/add.js`,
{
method: 'POST',
headers: {
'Content-Type': 'application/json',
Accept: 'application/json'
},
body: JSON.stringify({ items })
}
);

const result = await response.json();

if (!response.ok) {
throw new Error(
result.description ||
result.message ||
'The customized stack could not be added.'
);
}

/*
* Go to the cart after all items are successfully added.
* This guarantees the customer sees the complete stack.
*/
window.location.href = `${rootUrl}cart`;
} catch (error) {
console.error(
'Stackwell customized stack error:',
error
);

if (messageElement) {
messageElement.textContent =
error.message ||
'Something went wrong. Please try again.';

messageElement.hidden = false;
} else {
window.alert(
error.message ||
'Something went wrong. Please try again.'
);
}

if (submitButton) {
submitButton.disabled = false;
submitButton.removeAttribute('aria-busy');
}
}
},
true
);
}

function initializeAllStackwellFeatures() {
initializeAllStackwellAddOns();

document
.querySelectorAll('[data-stackwell-add-ons]')
.forEach(initializeStackwellCartConnection);
}

document.addEventListener(
'DOMContentLoaded',
initializeAllStackwellFeatures
);

document.addEventListener(
'shopify:section:load',
initializeAllStackwellFeatures
);

initializeAllStackwellFeatures();
  } catch(e) { console.error(e); }
})();

})();
